import { Close } from '@components/icons/close'
import { Menu } from '@components/icons/menu'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'
import { useRef } from 'react'

import styles from './hamburger-button.module.scss'

export const HamburgerButton: FunctionComponent<Props> = ({
    open,
    onClick,
}) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null)

    return (
        <button
            data-testid='header.mobile.navToggle'
            ref={buttonRef}
            aria-expanded={open}
            aria-controls='menu'
            className={classNames(
                styles.button,
                open && styles['button-active'],
            )}
            onClick={onClick}
        >
            {open ? (
                <Close className={styles['close-icon']} />
            ) : (
                <Menu className={styles['open-icon']} />
            )}
        </button>
    )
}

interface Props {
    open: boolean
    onClick: () => void
}
